import { render, staticRenderFns } from "./Sys_userpriv.vue?vue&type=template&id=3c2ccef8&scoped=true&"
import script from "./Sys_userpriv.vue?vue&type=script&lang=js&"
export * from "./Sys_userpriv.vue?vue&type=script&lang=js&"
import style0 from "./Sys_userpriv.vue?vue&type=style&index=0&id=3c2ccef8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ccef8",
  null
  
)

export default component.exports